import { differenceInSeconds, format, formatDistance } from "date-fns";
import i18n from "@/plugins/i18n.js";
import { sv } from "date-fns/locale";

export const nowRegex = /^[Nn]ow$/;
export const relativeRegex =
  /^(-?\d+[mMhHdD])(-?\d+[mMhHdD])?(-?\d+[mMhHdD])?$/;

export default {
  methods: {
    humanDate(date, formatString = undefined) {
      if (date == "0001-01-01T00:00:00") return "N/A";
      return date !== undefined && date !== null
        ? format(
            typeof date === "string" ? new Date(date) : date,
            formatString !== undefined ? formatString : "dd MMM - HH:mm",
          )
        : "N/A";
    },

    timeFromDays(days) {
      return days * 24 * 60 * 60 * 1000;
    },

    timeFromHours(hours) {
      return hours * 60 * 60 * 1000;
    },

    timeFromMinutes(minutes) {
      return minutes * 60 * 1000;
    },

    timeWithinMinutes(date1, minutes, date2) {
      if (date2 == undefined) date2 = new Date();
      return date2 - new Date(date1) < this.timeFromMinutes(minutes);
    },

    timeWithinHours(date, hours) {
      return new Date() - new Date(date) < this.timeFromHours(hours);
    },

    timeWithinDays(date, days) {
      return new Date() - new Date(date) < this.timeFromDays(days);
    },

    distanceAgo(date) {
      if (date == null) return "";

      let options = {};
      if (i18n.locale == "sv") options = { locale: sv };

      return formatDistance(new Date(date), new Date(), options);
    },

    differenceInSeconds(date1, date2) {
      date1 = new Date(date1);
      date2 = new Date(date2);
      return date1 == undefined || date2 == undefined
        ? NaN
        : differenceInSeconds(date1, date2);
    },

    toApiDate(date, encode = false) {
      let dt = this.humanDate(date, "yyyy-MM-dd HH:mm:ss");

      return encode ? encodeURIComponent(dt) : dt;
    },

    toISOStringKeepTimezoneOffset(date) {
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      return date.toISOString();
    },

    // If undefined is now is true
    isNow(d) {
      if (d == undefined) return true;

      return nowRegex.test(d);
    },

    isRelativeTime(d) {
      if (d == undefined) return false;

      return relativeRegex.test(d) || nowRegex.test(d);
    },

    getTimeRangeAsDates(range) {
      let start = this.isNow(range?.start) ? new Date() : new Date(range.start);
      let end = this.isNow(range?.end) ? new Date() : new Date(range.end);

      if (range?.end !== undefined && relativeRegex.test(range.end))
        end = this.relativeTimeFluxSyntax(range.end.split(relativeRegex));

      if (range?.start !== undefined && relativeRegex.test(range.start)) {
        start = this.relativeTimeFluxSyntax(
          range.start.split(relativeRegex),
          end,
        );
      }

      return {
        start: start,
        end: end,
      };
    },

    relativeTimeFluxSyntax(input, relativeEnd) {
      if (typeof input === "string") input = [input];

      let date = relativeEnd !== undefined ? relativeEnd : new Date();
      for (var modifier of input) {
        if (modifier == undefined || modifier == "") continue;

        let negative = modifier.charAt(0) == "-";
        if (negative) modifier = modifier.substring(1);

        let idx = modifier.search(/[mMhHdD]/);
        if (idx == -1) continue;

        let value = modifier.substring(0, idx);
        switch (modifier.substring(idx)) {
          case "m":
          case "M":
            date = negative
              ? new Date(date.getTime() - this.timeFromMinutes(value))
              : new Date(date.getTime() + this.timeFromMinutes(value));
            break;

          case "h":
          case "H":
            date = negative
              ? new Date(date.getTime() - this.timeFromHours(value))
              : new Date(date.getTime() + this.timeFromHours(value));
            break;

          case "d":
          case "D":
            date = negative
              ? new Date(date.getTime() - this.timeFromDays(value))
              : new Date(date.getTime() + this.timeFromDays(value));
            break;
          default:
            console.error(
              "Error trying to parse time identifier: ",
              modifier.substring(idx),
            );
            break;
        }
      }
      return date;
    },
  },
};
